import type { ReactNode } from 'react';

const mobileOnlyBr = () => <br className="block md:hidden" />;

const desktopOnlyBr = () => <br className="hidden md:block" />;

const solidBr = () => <br className="block" />;

// 인라인 볼드 태그 — t.rich() 에서 <strong>텍스트</strong> 구문 사용 시 렌더링
const inlineStrong = (chunk: ReactNode) => (
  <strong className="font-bold">{chunk}</strong>
);

// 인라인 반응형 텍스트 — 같은 단어가 데스크탑/모바일에서 다른 줄에 놓여야 할 때 사용.
// (<br>류는 줄바꿈, <desktopText>/<mobileText>는 텍스트 조각을 브레이크포인트별로 보임/숨김)
const desktopText = (chunk: ReactNode) => (
  <span className="hidden md:inline">{chunk}</span>
);

const mobileText = (chunk: ReactNode) => (
  <span className="inline md:hidden">{chunk}</span>
);

export const customRichTextTags = {
  br: desktopOnlyBr,
  mobileBr: mobileOnlyBr,
  solidBr: solidBr,
  strong: inlineStrong,
  desktopText: desktopText,
  mobileText: mobileText,
} as const;
